import { render, staticRenderFns } from "./GeneralToolsGlobalCard.vue?vue&type=template&id=d245f80a&scoped=true&"
import script from "./GeneralToolsGlobalCard.vue?vue&type=script&lang=js&"
export * from "./GeneralToolsGlobalCard.vue?vue&type=script&lang=js&"
import style0 from "./GeneralToolsGlobalCard.vue?vue&type=style&index=0&id=d245f80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d245f80a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VCard,VHover})
